import React, { Component } from "react";
import "./checkNumber.scss";
import { Toast, WhiteSpace, WingBlank, Button, Tag } from "antd-mobile";
import axios from "../axios";

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class checkNumber extends React.Component {

    state =  {
        selectList:[
            {
                title: "单张",
                tags : 'DZ', 
                numbers: 1, 
            },
            {
                title: "十张",
                tags : 'SZ',
                numbers: 10,
            },
            {
                title: "二十张",
                tags : 'ESZ',
                numbers: 20,
            },
            {
                title: "百张",
                tags : 'BZ',
                numbers: 100,
            },
            {
                title: "千张",
                tags : 'QZ',
                numbers: 1000,
            },
            {
                title: "连号",
                tags : 'LH',
                numbers: 1,
            },
        ],
        
        resultObject: [],//接口返回信息

        firstTitle : "",
        secondTitle : "",
        pid : "p010100", // 一级分类id
        cateId : "", //二级分类id
        crownNumber : "", //冠号
        startNumber : "", //输入起始号码
        numbersTags : "", //选中的数量
        numbers : '',
        cateType : "",//获取行情tag

        firstTitle_over :'',//一级分类过渡
        firstTitleKey_over : 0,
        secondTitle_over : '',//二级分类过渡
        secondTitleKey_over : 0,
        prefixArray : [],//冠号数组
        prefixCount : "",//冠号的限制条件
        charLen : '',//输入号码+冠号的总长度
        startChar: '',//输入号码首号码必需为这个数
        classificationVisible : false,
        crownNumberVisible : false,
        crownNumber_readonly : true,
        selectCtcrownNumberArray : [],

        startNumberClassName : 'numberinput',
        startNumberPrompt : '',

    };

    getUrlParam = (name) => {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = this.props.location.search.substr(1).match(reg);
        if (r != null) {
          return decodeURI(r[2]);
        }
        return ""; //如果此处只写return;则返回的是undefined
    };

    clickCheckButton = () => {

        if (this.state.cateId.length < 1) {
            Toast.show("请选择要查询的名称", 2);
            return;
        }

        if (this.state.crownNumber < 1) {
            Toast.show("请选择或输入冠号", 2);
            return;
        }

        if (this.state.startNumber.length < 1){
            Toast.show("请输入要查询的号码", 2);
            return;
        }

        if (this.state.numbers.length < 1){
            Toast.show("请选择查询号码的张数", 2);
            return;
        }
        
        //号码位数长度必须与规定一样
        if (this.state.charLen){
            if (this.state.charLen.length) {
                let charLenlength = Number(this.state.charLen);
                let crownNumberLength =  Number(this.state.crownNumber.length);
                let startNumberlength = Number(this.state.startNumber.length);
                
                if (!(charLenlength == crownNumberLength + startNumberlength)){
                    let startNumberPrompt = "号码长度最少"+ (charLenlength - crownNumberLength) + "位";
                    this.setState({
                        startNumberPrompt : startNumberPrompt,
                        startNumberClassName : 'numberinputRed'
                    })
                    return;
                }
            }
        }
        
        //号码首位必须与规定一样
        let startChar = this.state.startChar;
        if (startChar) {
            if (startChar.length) {
                if (!(startChar == this.state.startNumber.substring(0,startChar.length))) {
                    let startNumberPrompt = "第一位号码必须是"+startChar;
                    this.setState({
                        startNumberPrompt : startNumberPrompt,
                        startNumberClassName : 'numberinputRed'
                    })
                    return;
                }
            }
        }

        sessionStorage.setItem("checkNumberdata",JSON.stringify(this.state));
        this.props.history.push(`./checkNumberDetils?cateId=${this.state.cateId}&prefix=${this.state.crownNumber}&numType=${this.state.numbers}&number=${this.state.startNumber}&cateType=${this.state.cateType}&v=${this.getUrlParam('v')}`); 
    };
     /**
      * 点击AI估价
      */
    clickAIValuationButton = () =>{
        
    };

    clickClassificationName = () =>{

        this.setState({
            classificationVisible : true,
        })

    }

    clickFirstClassification = (item, key)=> {//选择了弹窗的第一分类
    
        var element1 = document.getElementById('classificationTab_ulid');
        element1.scrollTop = 0;

        this.setState({
            firstTitleKey_over : key,
            firstTitle_over : item.pTitle,
            secondTitle_over : '',
        })

    }

    clickClassificationSelect = (item, key) => {//选择了弹窗的第二分类选择

        // console.log(item, key);

        this.setState({
            secondTitleKey_over : key,
            secondTitle_over : item.title,
        })

    };

    clickCrownNumberSelect = () => {//点击选择冠号
        if (this.state.prefixArray.length > 3) {//判断是否显示选择冠号弹窗
            this.setState({
                crownNumberVisible : true,
            })
        }
    };

    closeDialog = () => {
        this.setState({
            classificationVisible : false,
            crownNumberVisible : false,
        })
    }

    sureSelectClassification = () => {//点击了分类选择的确认按钮

        if (this.state.secondTitle_over.length <1) {
            Toast.show("请选择要查询的名称", 3);
            return;
        }else{
            
            let prefix = this.state.resultObject[this.state.firstTitleKey_over].children[this.state.secondTitleKey_over].prefix;
            let prefixCount = this.state.resultObject[this.state.firstTitleKey_over].children[this.state.secondTitleKey_over].prefixCount;//冠号的限制条件
            let cateId = this.state.resultObject[this.state.firstTitleKey_over].children[this.state.secondTitleKey_over].cateId;/* 获取ID*/
            let cateType = this.state.resultObject[this.state.firstTitleKey_over].children[this.state.secondTitleKey_over].cateType;/* 获取行情tag*/
            let charLen = this.state.resultObject[this.state.firstTitleKey_over].children[this.state.secondTitleKey_over].charLen;/* 获取长度限制*/
            let startChar = this.state.resultObject[this.state.firstTitleKey_over].children[this.state.secondTitleKey_over].startChar;/* 获取首号码输入限制*/

            this.judgeCrownNumberType (prefix);

            this.setState({
                firstTitle : this.state.firstTitle_over,
                secondTitle : this.state.secondTitle_over,
                cateId : cateId,
                classificationVisible : false,
                prefixCount : prefixCount,
                cateType : cateType,
                charLen : charLen,
                startChar : startChar,
                startNumberClassName : 'numberinput',
                startNumberPrompt : "",
            })
        }   
    }

    judgeCrownNumberType = (prefix) => {/**判断冠号类型 */

        var prefixArray = [];
        let crownNumber = "";
        var crownNumber_readonly = this.state.crownNumber_readonly;

        if (prefix.length >3) {

            prefixArray = prefix.split(",");
            crownNumber = "选择冠号";

          }else if (prefix.length == 1) {

              crownNumber = prefix;
              crownNumber_readonly = true;
      
          }else{
              crownNumber = "";
              crownNumber_readonly = false;
          }

          this.setState({
            crownNumber_readonly : crownNumber_readonly,
            crownNumber : crownNumber,
            prefixArray : prefixArray,
        })
    }

    inputCrownNumber = (ev) => {/**输入冠号 */
        
        var crownNumber  = this.state.crownNumber;
        var value = ev.target.value;
        if (this.state.prefixCount.length > 0) {
            var prefixCountArray = this.state.prefixCount.split(",");
            // console.log(this.state.prefixCount, prefixCountArray);
            if (prefixCountArray.length) {
                let maxprefixCount = prefixCountArray[prefixCountArray.length - 1];
                if (value.length > maxprefixCount) {
                    Toast.show("最多输入" + maxprefixCount + "冠号", 2);
                }else{
                    crownNumber = value.toUpperCase();
                }
            }else if (value.length > this.state.prefixCount){
                Toast.show("最多输入" + this.state.prefixCount + "冠号", 2);
            }else{
                crownNumber = value.toUpperCase();
            }
        }else{
            crownNumber = value.toUpperCase();
        }

        //判断总体长度是否大于限制长度，大于限制长度的截取起始号码的后面多出来的几位
        var startNumber = this.state.startNumber;
        if (startNumber.length) {
            var numberLength = Number(this.state.charLen) - crownNumber.length;
            if (startNumber.length > numberLength ) {
                startNumber = startNumber.substring(0,numberLength);
                this.setState ({
                    startNumber : startNumber,
                })
            }
        }
        
        this.setState({
            crownNumber : crownNumber,
            startNumberClassName : 'numberinput',
            startNumberPrompt : "",
        })

    }

    clickCtcrownNumberSelect = (item, key) =>{//点击弹窗的冠号选择冠号

        var prefixCountArray = this.state.prefixCount.split(",");

        if (prefixCountArray.length) {
            let maxprefixCount = prefixCountArray[prefixCountArray.length - 1];
            if (this.state.selectCtcrownNumberArray.length == maxprefixCount) {
                return;
            }
        }else if (this.state.selectCtcrownNumberArray.length == this.state.prefixCount){
            return;
        }

        var selectCtcrownNumberArray  = this.state.selectCtcrownNumberArray.concat(item);
        this.setState({
            selectCtcrownNumberArray : selectCtcrownNumberArray,
        })

    }

    cacheSelectCtcrownNumber =() =>{//点击了清除冠号

        this.setState({
            selectCtcrownNumberArray : [],
        })
    }

    sureCrownNumber = () => {//点击了确认冠号按钮

        var selectCtcrownNumberArray = this.state.selectCtcrownNumberArray;
        var prefixCountArray = this.state.prefixCount.split(",");
        if (prefixCountArray.length) {
            let minprefixCount = prefixCountArray[0];
            if (selectCtcrownNumberArray.length < minprefixCount ) {
                Toast.show("最少选择" + minprefixCount + "冠号", 2);
                return;
            }
        }else if (selectCtcrownNumberArray.length < this.state.prefixCount){
            Toast.show("最少选择" + this.state.prefixCount + "冠号", 2);
            return;
        }

        let crownNumber = selectCtcrownNumberArray.join("");

        this.setState({
            crownNumberVisible : false,
            crownNumber : crownNumber,
            startNumberClassName : 'numberinput',
            startNumberPrompt : "",
        })
    }

    inputStartNumber = (ev) => {
        var crownNumber = this.state.crownNumber;
        var startNumber = this.state.startNumber;
        var value = ev.target.value;
        var numbezz = /^[0-9]+$/;
        var numberLength = Number(this.state.charLen) - crownNumber.length;
        
        if (value.length >startNumber.length) {
            if (!numbezz.test(value)){
                Toast.show("请输入数字", 2);
            }else if (value.length > numberLength ){
                Toast.show("最多输入"+ numberLength + "位号码", 2);
            }else{
                startNumber = value;
            }
        }else{
            startNumber = value;
        }
        
        this.setState ({
            startNumber : startNumber,
            startNumberClassName : 'numberinput',
            startNumberPrompt : "",
        })

    }

    clickNumbersSelect = (item, key) => {
        this.setState({
            numbersTags : item.tags,
            numbers : item.numbers,
        })
    };

    inputNumbers = (ev) => {

        var numbers = this.state.numbers;
        var value = ev.target.value
        var numbezz = /^[0-9]+$/;
        if (value.length) {
            if (!numbezz.test(value)){
                Toast.show("请输入数字", 2);
            }else if (value > 100) {
                Toast.show("最大只能输入100", 2);
            }else if (value < 1){
                Toast.show("请输入有效数字", 2);
            }else{
                numbers = value;
            }
        }else{
            numbers = value;
        }
        
        this.setState ({
            numbers : numbers,
        })
    };

    addShareContent = () => {
        let shareUrl = window.location.href.split('?')[0] + "?v=" + this.getUrlParam('v');
        var shareInfo = {
            shareUrl : shareUrl,
            shareTitle : "邮宝APP查号码",
            shareDesc : "买卖邮币卡，行情价格邮宝查",
        }
        var ua = navigator.userAgent.toLowerCase();
        var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
        if (isApp) {
            if (isiOS) {
                try {
                    window.webkit.messageHandlers.IOSNativeShareContent.postMessage(shareInfo);
                } catch (e) {
                }
            }else{
                try {
                    window.app.androidNativeShareContent(JSON.stringify(shareInfo));
                } catch (e) {
                }
            }
        }
    };

    componentDidMount () {

        if (this.getUrlParam('tokenHead').length > 0 && this.getUrlParam('tokenCode').length > 0) {
            sessionStorage.setItem("Authorization",this.getUrlParam('tokenHead')+' '+this.getUrlParam('tokenCode'));
        }
        if (this.getUrlParam('userId').length > 0) {
            sessionStorage.setItem("YBUserId",this.getUrlParam('userId'));
        }
       const _this = this;
       let localtemp = JSON.parse(sessionStorage.getItem('checkNumberdata'));
       if (localtemp) {
            _this.setState({
                resultObject: localtemp.resultObject,//接口返回信息
                firstTitle : localtemp.firstTitle,
                secondTitle : localtemp.secondTitle,
                pid : localtemp.pid, // 一级分类id
                cateId : localtemp.cateId, //二级分类id
                crownNumber : localtemp.crownNumber, //冠号
                startNumber : localtemp.startNumber, //输入起始号码
                numbersTags : localtemp.numbersTags, //选中的数量
                numbers : localtemp.numbers,
                cateType : localtemp.cateType,//获取行情tag
                charLen  : localtemp.charLen,
                startChar : localtemp.startChar,

                firstTitle_over :localtemp.firstTitle_over,//一级分类过渡
                firstTitleKey_over : localtemp.firstTitleKey_over,
                secondTitle_over : localtemp.secondTitle_over,//二级分类过渡
                secondTitleKey_over : localtemp.secondTitleKey_over,
                prefixArray : localtemp.prefixArray,//冠号数组
                prefixCount : localtemp.prefixCount,//冠号的限制条件
                classificationVisible : localtemp.classificationVisible,
                crownNumberVisible : localtemp.crownNumberVisible,
                crownNumber_readonly : localtemp.crownNumber_readonly,
                selectCtcrownNumberArray : localtemp.selectCtcrownNumberArray,
            })
       } else {
                axios
                .post("fbusiness/json/getNumberCategory").then(function (response){
                // console.log(response);
                    if (response.data.code === 10000) {
                        let resultObject = response.data.resultObject;
                
                        for (let i = 0; i < resultObject.length; i++) {
                            let firstObject = resultObject[i];
                            if (_this.state.pid == firstObject.pid ) {
                                _this.state.firstTitle_over = firstObject.pTitle;
                                _this.state.firstTitle = firstObject.pTitle;
                                if (firstObject.children.length > 0) {
                                    let secondObject = firstObject.children[0];
                                    let prefix = secondObject.prefix;
                                    _this.judgeCrownNumberType(prefix);

                                    _this.setState({
                                        firstTitle : firstObject.pTitle,
                                        firstTitle_over : firstObject.pTitle,
                                        firstTitleKey_over : i,
                                        secondTitle : secondObject.title,
                                        secondTitle_over : secondObject.title,
                                        secondTitleKey_over : 0,
                                        cateId : secondObject.cateId,
                                        cateType : secondObject.cateType,
                                        charLen  : secondObject.charLen,
                                        startChar : secondObject.startChar,
                                    })
                                    break;
                                }
                            }  
                        }
                        _this.setState({
                            resultObject : resultObject,
                        });
                        
                    }else {
                        let message = response.data.message;
                        Toast.show(message, 2);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }   
            
        _this.addShareContent();
    }

    render() {
        return (
            <div className="firstCheckNumber">
                 <header className="header">
                    <img src = "http://image.ybk008.com/checkNumberheader.png" />
                </header>

                {this.state.classificationVisible ? (
                    <div className="dialogModal">
                        <div className="dialogMain">
                            <div className="dialogTitle">
                                <p className="dialogTitle_p">选择品种及名称</p>
                                <span className="closeIcon" onClick={() => {this.closeDialog()}}>×</span>   
                            </div>
                            <div className="tabList_x" id="classification_divid" >
                                {
                                    this.state.resultObject.map((item, key) => (
                                        <span id={"classification_id" + key} key={key + 100} className={item.pTitle == this.state.firstTitle_over?'tab active':'tab'} onClick={() => this.clickFirstClassification(item, key)}>{item.pTitle}</span>
                                    ))
                                }
				            </div>

                            <ul id="classificationTab_ulid">
                                {
                                this.state.resultObject[this.state.firstTitleKey_over].children.map((item,key) => (
                                        <li key={key + 200} className="classificationTab_li" >
                                            <div className="classificationTab_div" onClick={()=>this.clickClassificationSelect(item, key)}>
                                                <img className="classificationTab_img" src={item.title == this.state.secondTitle_over ? require("../assets/cf_select@2x.png") : require("../assets/cf_noselect@2x.png")}></img>
                                                <p className="classificationTab_p">{item.title}</p>
                                            </div>
                                        </li>
                                ))
                                }   
                            </ul>

                            <div className="classification_footerdiv">
                                <button className="classification_cancel"onClick={() => {this.closeDialog()}}> 取消</button>
                                <button className="classification_sure" onClick={() =>{this.sureSelectClassification()}}> 确认</button>
                            </div>
                            
                        </div>
                    </div>
                 ) : null
                }

                {this.state.crownNumberVisible ? (
                    <div className="dialogModal">
                        <div className={ this.state.selectCtcrownNumberArray.length > 0 ? "dialogMain crownNumber_selectDiv" : "dialogMain crownNumber_div"}>
                            <div className="dialogTitle"> 
                                <p className="dialogTitle_p">按次序选择罗马数字</p>
                                <span className="closeIcon" onClick={() => {this.closeDialog()}}>×</span>
                            </div>

                            {this.state.selectCtcrownNumberArray.length  > 0 ? 
                                <div className="showSelectCtcrownNumber">
                                    {this.state.selectCtcrownNumberArray.map((item, key) =>(
                                        <button key={key + 500} className="showSelectCtcrownNumber_but" >{item}</button>
                                    ))} 
                                </div>

                            : null}

                            <ul className ="crownNumber_ul">
                                {this.state.prefixArray.map((item, key) => (
                                    <li key={key + 600} className="selectcrownNumberlist" onClick={() => this.clickCtcrownNumberSelect(item, key)}>
                                        <div className="selectcrownNumber_div">
                                        <button className="selectcrownNumber_button" >{item}</button>
                                        </div>   
                                    </li>
                                ))}
                            </ul>

                            <div className="classification_footerdiv">
                                <button className="classification_cancel" onClick={() => {this.cacheSelectCtcrownNumber()}}> 清除</button>
                                <button className="classification_sure" onClick={() =>{this.sureCrownNumber()}}> 确认</button>
                            </div>
                            
                        </div>
                    </div>
                 ) : null}

                <main>
                    <div className="divContent">

                        <div className="classificationView">

                            <div className="leftButtonView" onClick={() => this.clickClassificationName()}>
                                <button className="leftButton"> {this.state.firstTitle}</button>
                                <img className="arrowImage" src={require("../assets/YB_Arrow_grey_icon.png")} ></img>
                            </div>
                            
                            <div className="rightButtonView" onClick={() => this.clickClassificationName()}>
                                <button className="rightButton" >{this.state.secondTitle}</button>
                                <img className="arrowImage" src={require("../assets/YB_Arrow_grey_icon.png")} ></img>
                            </div>

                            <div className="leftButtonView">
                                {this.state.prefixArray.length > 0 || this.state.crownNumber_readonly ?
                                <button className="twoLeftButton" onClick={() => this.clickCrownNumberSelect()} >{this.state.crownNumber}</button> 
                                : 
                                <input className="crownNumberinput" type="text" placeholder="请输入冠号" onChange={(ev) => this.inputCrownNumber(ev)} value={this.state.crownNumber}/>
                                }
                            </div>

                            <div className="startNumberView">
                                <input className={this.state.startNumberClassName} type="text" placeholder="请输入起始号码"  onChange={(ev) => this.inputStartNumber(ev)} value={this.state.startNumber}/>
                                <p className="numberPrompt">{this.state.startNumberPrompt}</p>
                            </div> 

                        </div>

                        
                    </div>


                    <div className="selectNumbers_div1">
                       <div className="selectNumbers_div2">
                            {this.state.selectList.map((item, key) => (
                                    <div key={key + 700} className="selectNumbers_div3" onClick={() => this.clickNumbersSelect(item, key)}>
                                        <img className="selectnumbersImage" src={item.tags == this.state.numbersTags ? require("../assets/Selected.png") : require("../assets/Unselected.png")} ></img>
                                        <p className="selectNumbers_p">{item.title}</p>
                                    </div>
                            ))}
                            {this.state.numbersTags == "LH" ?
                               <input className="selectNumbers_input" type="number" placeholder="请输入号码数量(1~100)" onChange={(ev) => this.inputNumbers(ev)} value={this.state.numbers}/>
                             : null}
                        
                        </div>     
                    </div>

                    <div className="check_div">
                        <button className="check_button" onClick={() => this.clickCheckButton()}>查询</button>
                        {/* <button className="aivaluation_button" onClick={() => this.clickAIValuationButton()}>AI估价</button> */}
                    </div>
                    
                </main>

           </div>
        );   
    }
}
export default checkNumber;